(() => {
  const form = document.querySelector('[data-fcol-form]');
  if (!form) return;
  const submit = () => {
    const fd = new FormData(form), q = new URLSearchParams();
    for (const [k, v] of fd.entries()) if (v !== '') q.append(k, v);
    location.href = form.getAttribute('action') + (q.toString() ? '?' + q : '') + '#fcol-grid';
  };
  form.addEventListener('change', e => { if (e.target.matches('[data-fcol-auto], .fcol-check input')) submit(); });
  form.addEventListener('submit', e => { e.preventDefault(); submit(); });
  const filters = [...form.querySelectorAll('.fcol-filter')];
  filters.forEach(d => d.addEventListener('toggle', () => { if (d.open) filters.forEach(o => o !== d && (o.open = false)); }));
  document.addEventListener('click', e => { if (!e.target.closest('.fcol-filter')) filters.forEach(d => (d.open = false)); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') filters.forEach(d => (d.open = false)); });
})();

/* Shared nav: dropdowns, mobile menu, scroll state (pages without their own page script) */
(() => {
  const nav = document.getElementById('nav');
  if (!nav || nav.dataset.ffNav) return; nav.dataset.ffNav = '1';
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  let lastY = 0;
  const onScroll = () => {
    const y = scrollY;
    nav.classList.toggle('is-scrolled', y > 10);
    nav.classList.toggle('is-hidden', y > 600 && y > lastY + 4 && !nav.classList.contains('menu-open') && !nav.querySelector('.dd.is-open'));
    if (y < lastY - 4) nav.classList.remove('is-hidden');
    lastY = y;
  };
  addEventListener('scroll', onScroll, { passive: true }); onScroll();
  const dds = $$('.dd', nav), burger = $('#burger');
  const hover = matchMedia('(hover:hover) and (min-width:961px)');
  const close = (except) => dds.forEach(d => { if (d !== except) { d.classList.remove('is-open'); const b = $('.dd__btn', d); if (b) b.setAttribute('aria-expanded', 'false'); } });
  dds.forEach(d => {
    const btn = $('.dd__btn', d); if (!btn) return; let t;
    const open = () => { close(d); d.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
    btn.addEventListener('click', () => d.classList.contains('is-open') ? close() : open());
    d.addEventListener('pointerenter', () => { if (hover.matches) { clearTimeout(t); open(); } });
    d.addEventListener('pointerleave', () => { if (hover.matches) t = setTimeout(() => close(), 160); });
    d.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); btn.focus(); } });
  });
  document.addEventListener('click', e => { if (!nav.contains(e.target)) close(); });
  if (burger) {
    const setMenu = (on) => { nav.classList.toggle('menu-open', on); burger.setAttribute('aria-expanded', on); burger.setAttribute('aria-label', on ? 'Close menu' : 'Open menu'); document.body.style.overflow = on ? 'hidden' : ''; };
    burger.addEventListener('click', () => setMenu(!nav.classList.contains('menu-open')));
    $$('.menu a', nav).forEach(a => a.addEventListener('click', () => { setMenu(false); close(); }));
  }
})();
